import { useEffect, useState } from 'react';

/**
 * Phones only: true while the visitor scrolls DOWN the page, so floating
 * buttons (WhatsApp, chat) can slide out of the way of what they're reading —
 * on a 375px screen the two round buttons sat on top of card titles and
 * "See rooms" buttons. They come back on any scroll up, after a short pause,
 * near the top of the page, and always on tablets/desktops.
 */
export default function useHideOnScrollDown({ pauseMs = 900, topZone = 160, minDelta = 6 } = {}) {
    const [hidden, setHidden] = useState(false);
    useEffect(() => {
        if (typeof window === 'undefined') return undefined;
        let lastY = window.scrollY;
        let idle;
        const onScroll = () => {
            const y = window.scrollY;
            const delta = y - lastY;
            lastY = y;
            clearTimeout(idle);
            if (window.innerWidth >= 768 || y < topZone) { setHidden(false); return; }
            if (delta > minDelta) setHidden(true);
            else if (delta < -minDelta) setHidden(false);
            idle = setTimeout(() => setHidden(false), pauseMs);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => { window.removeEventListener('scroll', onScroll); clearTimeout(idle); };
    }, [pauseMs, topZone, minDelta]);
    return hidden;
}
